"use client"

import { commonStylesProps } from "@/(admin)/modules/ui-builder/config/lib/commonCSSProps"
import type { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"
import type { BecomeTDFCustomerProps } from "./types"

export const BecomeTDFCustomer: ComponentConfig<BecomeTDFCustomerProps> = {
  label: "Tamda One | Become TDF Customer",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    description: {
      label: "Description",
      type: "textarea",
    },
    quickRegistrationText: {
      label: "Quick Registration Text",
      type: "text",
    },
    freeRegistrationText: {
      label: "Free Registration Text",
      type: "text",
    },
    successTitle: {
      label: "Success Title",
      type: "text",
    },
    submittedMessage: {
      label: "Submitted Message",
      type: "text",
    },
    registrationEmail: {
      label: "Fallback Email",
      type: "text",
    },
    registrationCode: {
      label: "Registration Code",
      type: "text",
    },
    noteTitle: {
      label: "Note Title",
      type: "text",
    },
    notes: {
      label: "Notes",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.text || `Note ${index + 1}`,
      arrayFields: {
        text: {
          label: "Text",
          type: "textarea",
        },
      },
    },
    countryOptions: {
      label: "Country Options",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.label || `Country ${index + 1}`,
      arrayFields: {
        label: {
          label: "Label",
          type: "text",
        },
        value: {
          label: "Value",
          type: "text",
        },
      },
    },
    storeOptions: {
      label: "Store Options",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.label || `Store ${index + 1}`,
      arrayFields: {
        label: {
          label: "Label",
          type: "text",
        },
        value: {
          label: "Value",
          type: "text",
        },
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "BECOME TDF CUSTOMER",
    description:
      "The key to a world of diverse goods, competitive prices and outstanding services and facilities!",
    quickRegistrationText: "Quick Registration",
    freeRegistrationText: "Completely FREE to sign up",
    successTitle: "SUCCESSFULLY SUBMITTED!",
    submittedMessage: "Your registration information has been sent to your email:",
    registrationEmail: "longtran@gmail.com",
    registrationCode: "PRAHA-2657",
    noteTitle: "LƯU Ý:",
    notes: [
      {
        text:
          "Khách hàng lưu giữ mã đăng ký và đưa cho nhân viên phục vụ tại quầy chăm sóc khách hàng của cửa hàng đã đăng ký để nhận thẻ thành viên",
      },
      {
        text: "Khi đi mang theo thẻ căn cước công dân",
      },
    ],
    countryOptions: [
      { label: "VietNam", value: "vn" },
      { label: "US", value: "us" },
    ],
    storeOptions: [
      { label: "Location at Hansinky", value: "hansinky" },
      { label: "Location at Timo", value: "timo" },
    ],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { BecomeTDFCustomerProps }
